import React from 'react';
import { Card } from 'antd';
import AntdProForm, {
  ProFormText,
  ProFormDatePicker,
  ProFormSelect,
} from '@ant-design/pro-form';
import PropTypes from 'prop-types';
import {
  SelectProjectCategory,
  SelectProjectType,
  SelectFaculty,
  SelectDepartment,
  SelectProjectStatus,
} from '../../../input';
import { WIDTH_2_COL } from '../../../../constants/form';

const GeneralForm = ({ form }) => (
  <Card title="General" style={{ marginBottom: '24px' }}>
    <ProFormText
      width={WIDTH_2_COL}
      name="title"
      label="Project Title"
      placeholder="Project Title"
      rules={[{ required: true, message: 'Please enter project title!' }]}
    />
    <AntdProForm.Group>
      <SelectProjectCategory />
      <SelectProjectType />
    </AntdProForm.Group>
    <AntdProForm.Group>
      <ProFormText
        width="xl"
        name="accountCode"
        label="Account Code"
        placeholder="Account code"
      />
      <ProFormText
        width="xl"
        name="workProgramme"
        label="Work Programme Code"
        placeholder="Work Programme Code"
      />
    </AntdProForm.Group>
    <ProFormText
      width="xl"
      name="projectCode"
      label="Project Code"
      placeholder="Project Code"
      rules={[{ required: true, message: 'Please enter project code!' }]}
    />
    <AntdProForm.Group>
      <ProFormDatePicker
        width="xl"
        name="accountSetUpDate"
        label="Account Set Up Date (YYYY-MM-DD)"
        placeholder="Account Set Up Date"
        rules={[
          { required: true, message: 'Please select account set up date!' },
        ]}
      />
      <ProFormDatePicker
        width="xl"
        name="accountClosedDate"
        label="Account Closed Date (YYYY-MM-DD)"
        placeholder="Account Closed Date"
      />
    </AntdProForm.Group>
    <ProFormSelect
      name="researchRelated"
      label="Research-oriented or with research elements"
      width="xl"
      options={[
        { label: 'Yes', value: 'YES' },
        { label: 'No', value: 'NO' },
        { label: 'N/A', value: 'NA' },
      ]}
      rules={[{ required: true, message: 'Please select!' }]}
    />
    <AntdProForm.Group>
      <SelectFaculty />
      <SelectDepartment form={form} />
    </AntdProForm.Group>
    <SelectProjectStatus
      rules={[{ required: true, message: 'Please select!' }]}
    />
  </Card>
);

GeneralForm.propTypes = {
  form: PropTypes.object.isRequired,
};

export default GeneralForm;
